export default [
  {
    path: "/baice",
    children: [
      //students
      {
        path: "students",
        name: "baice-students",
        component: () => import("@/views/baice/students/index.vue"),
        meta: {
          title: "STUDENTS",
          authRequired: true,
          acc: 'y13985'
        },
      },
      {
        path: "view-student/:id",
        name: "baice-student",
        component: () => import("@/views/baice/students/view.vue"),
        meta: {
          title: "VIEW STUDENT",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "edit-student/:id",
        name: "baice-edit-student",
        component: () => import("@/views/baice/students/components/edit.vue"),
        meta: {
          title: "EDIT STUDENT",
        },
      },
      //register
      {
        path: "register",
        name: "baice-register",
        component: () => import("@/views/baice/register.vue"),
        meta: {
          title: "REGISTER",
        },
      },
      //Cas
      {
        path: "cas",
        name: "baice-cas",
        component: () => import("@/views/baice/cas/index.vue"),
        meta: {
          title: "BAICE CAS",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "regcas",
        name: "baice-regcas",
        component: () => import("@/views/baice/cas/withca.vue"),
        meta: {
          title: "BAICE REG CAS",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "nonreg",
        name: "baice-nonreg",
        component: () => import("@/views/baice/cas/withoutca.vue"),
        meta: {
          title: "BAICE NON REG CAS",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "editca",
        name: "baice-editca",
        component: () => import("@/views/baice/cas/edit.vue"),
        meta: {
          title: "BAICE UPDATE CA",
        },
      },
      //photo album
      {
        path: "photo_album",
        name: "baice-photo_album",
        component: () => import("@/views/baice/photo-album.vue"),
        meta: {
          title: "PHOTO ALBUM",
        },
      },
      //gazette
      {
        path: "gazette",
        name: "baice-gazette",
        component: () => import("@/views/baice/gazette/index.vue"),
        meta: {
          title: "GAZETTE",
        },
      },
    
      //student List
      {
        path: "student-list",
        name: "baice-student-list",
        component: () => import("@/views/baice/student-list.vue"),
        meta: {
          title: "STUDENT LIST",
          authRequired: true,
          acc: 'y54282'
        },
      },
      // exam card
      {
        path: "exam_card",
        name: "baice-student-examcard",
        component: () => import("@/views/baice/exam-card.vue"),
        meta: {
          title: "EXAM CARD",
          authRequired: true,
          acc: 'y54282'
          
        },
      },
  
      //subject Analysis
      {
        path: "subject-analysis",
        name: "baice-subject-analysis",
        component: () => import("@/views/baice/subject-analysis.vue"),
        meta: {
          title: "SUBJECT ANALYSIS",
        },
      },
      
    ],
  },
];
